// import AIcon from '@/components/A/AIcon/AIcon'
import styles from './LegendDot.module.less'
import { useTranslateDimension } from '../../../VideoAnalysis'
import cls from 'classnames'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'


interface Props {
  className?: string
  style?: React.CSSProperties
  mode?: 'select' | 'readonly'
  orientation?: 'landscape' | 'portrait'
  layout?: 'default' | 'side-list' | 'centered-row'
  size?: 'default' | 'compact'
  onDimensionChange?: (dimension: string[]) => void
}

function LegendDot(props: Props) {
  const mode = props.mode || 'readonly'
  const orientation = props.orientation || 'landscape'
  const layout = props.layout || 'default'
  const size = props.size || 'default'
  const { i18n } = useTranslation()
  const { EYE_MOVEMENT_RATIO, COGNITIVE_ENGAGEMENT, EMOTION_RECOGNITION } = useTranslateDimension()
  const [selectedDimension, setSelectedDimension] = useState<Record<string, boolean>>({
    [EYE_MOVEMENT_RATIO]: true,
    [COGNITIVE_ENGAGEMENT]: true,
    [EMOTION_RECOGNITION]: true,
  })

  const handleDimensionChange = (dimension: string) => {
    const dimensionItem = dimension as keyof typeof selectedDimension
    if (mode === 'select') {
      const newSelectedDimension = {
        ...selectedDimension,
        [dimensionItem]: !selectedDimension[dimensionItem]
      }
      // const allIsFalse = Object.values(newSelectedDimension).every(item => !item)
      /** 至少有一个指标 */
      // if (allIsFalse) { return }
      setSelectedDimension(newSelectedDimension)
    }
  }

  useEffect(() => {
    const dimension = Object.entries(selectedDimension).filter(([, value]) => value).map(([key]) => key)
    props.onDimensionChange?.(dimension)
  }, [selectedDimension])

  useEffect(() => {
    setSelectedDimension({
      [EYE_MOVEMENT_RATIO]: true,
      [COGNITIVE_ENGAGEMENT]: true,
      [EMOTION_RECOGNITION]: true,
    })
  }, [i18n.language])

  return (
    <div
      className={cls(
        styles.legend,
        orientation === 'portrait' && styles.portrait,
        layout === 'side-list' && styles.sideList,
        layout === 'centered-row' && styles.centeredRow,
        size === 'compact' && styles.compact,
        props.className
      )}
      style={props.style}
    >
      <div className={cls(styles.legendItem, selectedDimension[EYE_MOVEMENT_RATIO] && styles.selected, mode === 'select' && styles.clickable)}
        onClick={() => handleDimensionChange(EYE_MOVEMENT_RATIO)}>
        <span className={cls(styles.dot, styles.blue)}></span>
        {/* Icon 无法打印显示，这里换成 element 来做 */}
        {/* <AIcon width={42} type='icon-fill-global_bule' /> */}
        <span className={styles.legendItemText}>{EYE_MOVEMENT_RATIO}</span>
      </div>
      <div className={cls(styles.legendItem, selectedDimension[EMOTION_RECOGNITION] && styles.selected, mode === 'select' && styles.clickable)}
        onClick={() => handleDimensionChange(EMOTION_RECOGNITION)}>
        <span className={cls(styles.dot, styles.yellow)}></span>
        {/* Icon 无法打印显示，这里换成 element 来做 */}
        {/* <AIcon width={42} type='icon-fill-global_yellow' /> */}
        <span className={styles.legendItemText}>{EMOTION_RECOGNITION}</span>
      </div>
      <div className={cls(styles.legendItem, selectedDimension[COGNITIVE_ENGAGEMENT] && styles.selected, mode === 'select' && styles.clickable)}
        onClick={() => handleDimensionChange(COGNITIVE_ENGAGEMENT)}>
        <span className={cls(styles.dot, styles.purple)}></span>
        {/* Icon 无法打印显示，这里换成 element 来做 */}
        {/* <AIcon width={42} type='icon-fill-global_purple' /> */}
        <span className={styles.legendItemText}>{COGNITIVE_ENGAGEMENT}</span>
      </div>
    </div>
  )
}

export default LegendDot
